export default function Terms() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-200 px-6 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="font-mono text-xs text-[#ccff00] uppercase tracking-wider mb-3">
          TuneAmplifier
        </div>

        <h1 className="font-display text-4xl lg:text-5xl font-bold mb-3">
          Terms of Service
        </h1>

        <p className="text-sm text-zinc-500 mb-10">
          Last updated: August 17, 2026
        </p>

        <div className="space-y-8 text-sm leading-7 text-zinc-300">
          <section>
            <p>
              By using TuneAmplifier, you agree to these Terms of Service.
              TuneAmplifier provides tools for music promotion, social media
              content creation, analytics, publishing, and advertising
              management.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display font-bold text-white mb-3">
              Use of the Service
            </h2>
            <p>
              You are responsible for the content, accounts, music, media,
              advertising accounts, and third-party services that you connect
              to TuneAmplifier. You must have the necessary rights and
              permissions to use and publish the content you provide.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display font-bold text-white mb-3">
              Third-Party Accounts
            </h2>
            <p>
              TuneAmplifier can connect to third-party services such as
              Spotify, YouTube, Facebook, Instagram, TikTok, X, and advertising
              platforms. Your use of those services remains subject to their
              respective terms and policies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display font-bold text-white mb-3">
              Prohibited Use
            </h2>
            <p>
              You may not use TuneAmplifier for unlawful activity, fraud,
              unauthorized access, infringement of intellectual property, or
              abuse of third-party platforms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display font-bold text-white mb-3">
              Changes and Availability
            </h2>
            <p>
              We may change or discontinue features of TuneAmplifier from time
              to time. We do not guarantee uninterrupted availability of the
              service or third-party integrations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display font-bold text-white mb-3">
              Contact
            </h2>
            <p>
              TuneAmplifier
              <br />
              tuneamplifier@gmail.com
              <br />
              https://tuneamplifier.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
